import defiant from 'defiant.js/dist/defiant.js';

import getSnapshots from "./defiantSnapshots.js";
import {SearchTGSynonyms, XPathSynonyms} from "../../search/search.util.js";
import removeStopWords from "./stopWords.js";
import {determineGuideline, determineTopicFile} from "./xmlUtils.js";

const MAX_NUMBER_OF_SUGGESTIONS = 10;

const determineXpathExpression = (
    flattenedKeywords,
    synIndex,
    topicSearchResults = true
) => {

    const treatedWords = flattenedKeywords.map((word) => {
        return `contains(|key|, "${word}")`;
    });
    const batchWords = `${treatedWords.join(" and ")}`;

    const searchKeys = ["s"];

    const batchXpression = searchKeys.map((searchKey) => {
        return `${batchWords.replace(/\|key\|/g, searchKey)}`;
    });

    if (!topicSearchResults) {
        const expressions = flattenedKeywords.map(
            (word) => `contains(d, "${word}")`
        );
        const drugXpress = `//*[${expressions.join(" and ")}]`
            .replace(/\/\/\*\[/g, "(")
            .replace(/\)]/g, "))");
        batchXpression.push(drugXpress);
    }

    const combinedBatchExpression = `${batchXpression.join(" or ")}`;
    return `//*[${combinedBatchExpression}]`;
};

function determineXPathAndKeyword(searchIndex, synIndex, topicSearchResults) {
    const searchKeyword =
        searchIndex.charAt(searchIndex.length - 1) === "*"
            ? searchIndex.slice(0, -1)
            : searchIndex;
    const keywords = removeStopWords(searchKeyword)
        .toLowerCase()
        .split(" ")
        .map((word) => [word]);

    let flattenedKeywords = [].concat(...keywords);
    let xPathXpress = "//*[]";
    if (searchIndex.length >= 3)
        xPathXpress = determineXpathExpression(
            flattenedKeywords,
            synIndex,
            topicSearchResults
        );

    const kXPress = XPathSynonyms(synIndex);
    if (kXPress.length > 0) {
        if (searchIndex.length >= 4) {
            xPathXpress = xPathXpress.replace("]", kXPress + "]");
        } else {
            xPathXpress = `//*[${kXPress.replace(" or c", "c")}]`;
        }
    }
    return {
        xPathXpress,
        flattenedKeywords
    };
}

async function sortResults(results) {
    return results.reverse().splice(0, MAX_NUMBER_OF_SUGGESTIONS);
}


function formatSuggestion(searchText, text) {
    return text.toLowerCase().includes(searchText.toLowerCase()) ?
        text.replace(new RegExp(searchText, 'i'), match => `<em>${match}</em>`) :
        text;
}

async function formatResults(searchText, results) {
    return results.map((result) => {
        const guidelinePath = determineGuideline(result);
        const topicFile = determineTopicFile(guidelinePath, result);
        const generateUrl = `/viewTopic?etgAccess=true&guidelinePage=${encodeURIComponent(guidelinePath)}&navigateTopic=${topicFile}.ditamap#toc|0`
        return {
            suggestion: formatSuggestion(searchText, result.s),
            title: result.s,
            type: "topic",
            url: generateUrl
        }
    });
}

async function offlineSearchSuggestion(searchText) {
    console.log("Offline suggestions for search: ", searchText)
    const tgg = window.tgg;

    const synIndex = SearchTGSynonyms(searchText, tgg);
    const {topicSnapshot} = await getSnapshots();
    const topicSearchResults = false;
    const {
        xPathXpress: suggestionXpath,
    } = determineXPathAndKeyword(searchText, synIndex, topicSearchResults);
    const results = defiant.search(topicSnapshot, suggestionXpath);
    const sortedResults = await sortResults(results);
    return await formatResults(searchText, sortedResults)
}

export {
    offlineSearchSuggestion
};